import {
  getTokenRoleInfo,
  isCurrentUserAdmin,
  isCurrentUserSuperAdmin,
} from "@risalabs_frontend_org/auth-wrapper";
import {
  ConfigSectionType,
  CONFIG_SECTION_TYPES,
} from "../../shared/enums/rbacRoles";

export const isDevBypassEnabled = (): boolean =>
  process.env.REACT_APP_ENV !== "production" &&
  process.env.REACT_APP_DEV_BYPASS_AUTH === "true";

if (isDevBypassEnabled()) {
  // eslint-disable-next-line no-console
  console.warn(
    "[config-dashboard] REACT_APP_DEV_BYPASS_AUTH is on — RBAC checks bypassed. Production builds ignore this flag.",
  );
}

export const getCurrentRoleType = (): string | null => {
  return getTokenRoleInfo()?.type ?? null;
};

export const canAccessAnyConfig = (): boolean => {
  if (isDevBypassEnabled()) return true;
  return isCurrentUserSuperAdmin() || isCurrentUserAdmin();
};

export const canAccessSection = (section: ConfigSectionType): boolean => {
  if (isDevBypassEnabled()) return true;
  if (isCurrentUserSuperAdmin()) return true;
  if (!isCurrentUserAdmin()) return false;
  return getCurrentRoleType() === section;
};

/**
 * Super-admin-only items inside the Common section (Credentials Config, Health
 * Facility Config). The Common section itself is open to any config admin — see
 * `canAccessCommonSection`.
 */
export const canAccessCommonConfig = (): boolean => {
  if (isDevBypassEnabled()) return true;
  return isCurrentUserSuperAdmin();
};

/**
 * The Common section (tab + landing page) is visible to any config admin, super
 * admin or section admin. Individual super-admin-only items within it are gated
 * separately via `canAccessCommonConfig`.
 */
export const canAccessCommonSection = (): boolean => canAccessAnyConfig();

export const getDefaultSection = (): ConfigSectionType => {
  if (isDevBypassEnabled()) return "med_onc";
  if (isCurrentUserSuperAdmin()) return "med_onc";
  const type = getCurrentRoleType();
  if (type && (CONFIG_SECTION_TYPES as readonly string[]).includes(type)) {
    return type as ConfigSectionType;
  }
  return "med_onc";
};
